// reset link 301
$(function(){
  if(window.location.pathname == "/pages/current-coupons-promotions"){
    window.location.href="/pages/ever-pretty-coupons-promotions";
  }
});


$(function () {
  $(".plusSizeGuideBox1 .btn").click(function (event) {
      let ww = $(window).width();
      if(ww<=999){
        $('html, body').stop().animate({scrollTop: 400});
      }else{
        $('html, body').stop().animate({scrollTop: 600});
      }
  });
  $(".plusSizeGuideBox1 .btn").click(function () {
    var _data = $(this).attr("data-name");
    $(".plusSizeGuideBox1 .btn").removeClass("on");
    $(this).addClass("on");
    $(".plusSizeGuideBox1 .switch").removeClass("on");
    $(".plusSizeGuideBox1 .switch[data-name="+_data+"]").addClass("on");
  });
  $(".plusSizeGuideBox1 .productSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".plusSizeGuideBox3 .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 798,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $(".coupons_promotions_tab_content .tabBox .tab").click(function () {
    let _data = $(this).attr("data-name");
    $(".coupons_promotions_tab_content .tabBox .tab").removeClass("on");
    $(this).addClass("on");
    $(".coupons_promotions_tab_content .switchBox .switch").removeClass("on");
    $(".coupons_promotions_tab_content .switchBox .switch[data-name="+ _data +"]").addClass("on");
  });
});


$(function () {
  $("#dress-review-content .videoMenu li").eq(0).find("a").addClass("on");
  let _data = $("#dress-review-content .videoMenu li").eq(0).find("a").attr("data-name");
  $("#dress-review-content .videoTitle[data-name='"+ _data +"']").addClass("on");
  $("#dress-review-content .item[data-name='"+ _data +"']").addClass("on");

  $("#dress-review-content .videoMenu li a").click(function () {
    var _data_name = $(this).attr("data-name");
    $("#dress-review-content .videoMenu li a").removeClass("on");
    $(this).addClass("on");
    $("#dress-review-content .videoTitle").removeClass("on");
    $("#dress-review-content .item").removeClass("on");
    $("#dress-review-content .videoTitle[data-name='"+ _data_name +"']").addClass("on");
    $("#dress-review-content .item[data-name='"+ _data_name +"']").addClass("on");
  });
});

$(function () {
  $('#promDresses .conBox2 .itemBox').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('#promDresses .conBox6 .imgBox').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $("#promDresses .conBox7 .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });

  $(".motherBrideDressesBox9 .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });

  $(".homeComingDressesBox2 .conBox .text span.learn_more").bind('click',function(){
    $(this).hasClass("active") ? $(this).text("Learn More").removeClass("active") : $(this).text("See less").addClass("active");
    $(this).prev("div.t").toggleClass("active")
  });

  $(".homeComingDressesBox6 .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });

  $(".homeComingDressesBox6 .learn_more span").bind('click',function(){
    $(this).hasClass("active") ? $(this).text("Read More >").removeClass("active") : $(this).text("See less >").addClass("active");
    $(".homeComingDressesBox6 .other_item").slideToggle();
  });
});

$(function () {
  let ww = $(window).width();
  $(".bridesmaidBox1 .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 6,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 4,
        }
      }
    ]
  });
  $(".bridesmaidBox3 .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          centerMode: true,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: '50px',
          slidesToShow: 1,
        }
      }
    ]
  });
  $(".bridesmaidBox4 .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  if(ww <=999){
    $(".bridesmaidBox6 .itemBox").slick({
      dots: false,
      arrows: true,
      touchMove: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true
    })
  }

  $(".bridesmaidBox5 .tp").click(function () {
    $(this).parent().next("div.pofText").show();
  });
  $(".bridesmaidBox5 .pofText").find("span").click(function () {
    $(this).parent("div.pofText").hide();
  });

  $(".bridesmaid_fabric .product_list").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});

$(function () {
  $('.promDressesBox1Slick').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.promColorSlick').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.promDressesBox3 .itemBox').slick({
    dots: true,
    arrows: false,
    touchMove: false,
    speed: 300,
    slidesToScroll: 1,
    variableWidth: true,
  });

  $('.promDressesBox6 .imgBox').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});


$(function () {
  $(".formalDressesBox1Slick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: 0,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          dots: false,
          arrows: true,
          touchMove: false,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
  $(".formalColorSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 10,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 8
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  $(".formalDressesProductSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
  });
  $(".formalDressesInfoSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300
  });
  $(".formalDressesBox6 .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          dots: false,
          arrows: true,
          touchMove: false,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
});


$(function () {
  $(".weddingGuestColorSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 10,
    slidesToScroll: 1,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerMode: false,
          slidesToShow: 8
        }
      },
      {
        breakpoint: 999,
        settings: {
          centerMode: false,
          slidesToShow: 6
        }
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: false,
          slidesToShow: 5
        }
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: false,
          slidesToShow: 3
        }
      }
    ]
  });

  $(".weddingGuestDressesBox3 .listBox .list").hover(function () {
    let _data = $(this).attr("data-name");
    $(".weddingGuestDressesBox3 .item").removeClass("on");
    $(".weddingGuestDressesBox3 .item[data-name="+_data+"]").addClass("on");
  });

  $(".weddingGuestDressesProductSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $(".weddingGuestDressesPhotoGallery").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  let ww = $(window).width();
  if(ww<=750){
    $(".weddingGuestDressesBox3 .itemBox").slick({
      dots: false,
      arrows: true,
      touchMove: false,
      speed: 300
    });
  }
});

$(function () {
  $(".emPhotoSlick").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".emReviewSlick").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  
  $("#homeComingDresses .productColorSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $("#homeComingDresses .productSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $("#homecomingPillarBox .productSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $("#homecomingPillarBox .photoSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  $(".homecomingPillarBox3 .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });
});


$(function(){
  $("#groupBuyBox .box2 .item .tpBox a").click(function () {
    var _data = $(this).attr("data-name");
    $("#groupBuyBox .box2 .item .conBox, #groupBuyBox .box2 .item .text").removeClass("active");
    $("#groupBuyBox .box2 .item .text[data-name="+ _data +"]").addClass("active");
    $(this).parent().parent().parent().addClass("active");
  });
  $(".close-this").click(function () {
    $("#groupBuyBox .box2 .item .conBox, #groupBuyBox .box2 .item .text").removeClass("active");
  });

  $(".choir_shop_faq .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });


  
  $(".groupService .item .btn").click(function () {
    var _data = $(this).attr("data-name");
    $(".groupService .item .conBox, .groupService .item .tBox").removeClass("active");
    $(".groupService .item .tBox[data-name="+ _data +"]").addClass("active");
    $(this).parent().parent().parent().parent().addClass("active");
  });
  $(".groupService .close-this").click(function () {
    $(".groupService .item .conBox, .groupService .item .tBox").removeClass("active");
  });
  
  $(".groupDiscount .title a").click(function () {
    $(".groupDiscount, .groupDiscount .popBox").removeClass("active");
    $(".groupDiscount .popBox").addClass("active");
    $(".groupDiscount").addClass("active");
  });
  $(".groupDiscount .close-this").click(function () {
    $(".groupDiscount, .groupDiscount .popBox").removeClass("active");
  });

  $('.groupProduct .itemBox').slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $('.groupTemplateBox .gallerySlick').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    touchMove: false,
    variableWidth: true
  });

  
  $(".group_hot_sale .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          centerMode: true,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 540,
        settings: {
          centerMode: true,
          centerPadding: '50px',
          slidesToShow: 1,
        }
      }
    ]
  });
});


$(document).ready(function() {
  $(window).scroll(function() {
    var scrollPosition = $(window).scrollTop() + 10;
    
    $('.stickyHomeComingMenu a[href^="#"]').each(function() {
      var target = $(this.getAttribute('href'));
      
      if (target.length && scrollPosition >= target.offset().top && scrollPosition < target.offset().top + target.outerHeight()) {
        $('.stickyHomeComingMenu a[href^="#"]').removeClass('active');
        $(this).addClass('active');
      }
    });
  });
});

function countdown() {
  var _data = $(".countdownTime").attr("data-time")
  var targetDate = new Date(_data);
  var currentDate = new Date();
  var remainingTime = targetDate.getTime() - currentDate.getTime();
  if (remainingTime <= 0) {
    $(".countdownTime").text("This event has ended");
    return;
  }
  var days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
  var hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
  var formattedDays = days < 10 ? "0" + days : days;
  var formattedHours = hours < 10 ? "0" + hours : hours;
  var formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
  var formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
  $(".countdownTime #days").text(formattedDays);
  $(".countdownTime #hours").text(formattedHours);
  $(".countdownTime #minutes").text(formattedMinutes);
  $(".countdownTime #seconds").text(formattedSeconds);

  setTimeout(countdown, 1000);
}

$(document).ready(function() {
  countdown();
});


// formal dresses guide
$(function () {
  $(".formalFabrics .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});


$(function () {
  let ww = $(window).width();
  if(ww <= 640){
    $(".black-friday-2023-page .countdownContentBox .item .box").click(function () {
      $(this).parent("div.item").addClass("on");
    });
    $(".black-friday-event-2023 .bk-calendar .item .box").click(function () {
      $(this).parent("div.item").addClass("on");
    })
  }
  $(".black-friday-event-2023 .bk-best .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1220,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".black-friday-event-2023 .bk-collection .itemBox").slick({
    dots: true,
    arrows: false,
    touchMove: false,
    speed: 1000,
    rows: 2,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  
  $(".cyber-collection .itemBox").slick({
    dots: true,
    arrows: false,
    touchMove: false,
    speed: 1000,
    rows: 2,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});


$(function () {
  $(".ultimateGuideBox3 .product_list").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".ultimateGuideBox4 .btn").click(function () {
    var _data = $(this).attr("data-name");
    $(".ultimateGuideBox4 .btn").removeClass("on");
    $(this).addClass("on");
    $(".ultimateGuideBox4 .switch").removeClass("on");
    $(".ultimateGuideBox4 .switch[data-name="+_data+"]").addClass("on");
  });
  $(".ultimateGuideBox4 .productSlick").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".ultimateGuideBox6 .product_list").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".ultimateGuideBox7 .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});



$(function () {
  $(".holiday_dresses_template .color_trend .product_list").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".holiday_dresses_template .discounts_offers .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });


  $(".black-friday-event-2023 .bk-winter .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  $('.bk-discount span').click(function() {
    var data_code = $(this).attr("data-code");
    navigator.clipboard.writeText(data_code);
    var originalTitle = $(this).attr('title');
    $(this).attr('title', 'Copied successfully');
    setTimeout(function() {
      $(this).attr('title', originalTitle);
    }.bind(this), 5000);
  });
});

// Choir Dresses Page
$(function () {
  $(".choir_dresses_fabric .product_list").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
})

// Valentine's Day
$(function () {
  $(".popular_trend .product_list").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
})


// new wedding guest
$(function(){
  $(".weddingGuest_style .text").eq(0).addClass("on");
  $(".weddingGuest_style .image").eq(0).addClass("on");
  

  $(".weddingGuest_style .text").hover(function () {
    let _data = $(this).attr("data-name");
    $(".weddingGuest_style .image").removeClass("on");
    $(".weddingGuest_style .image[data-name="+_data+"]").addClass("on");
  });

  $(".weddingGuest_occasion .itemBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
});


$(function () {
  $(".military_faq .item").click(function () {
    if($(this).hasClass("on")){
      $(this).removeClass("on");
      $(this).find(".text").slideUp();
    }else{
      $(".military_faq .item").removeClass("on");
      $(this).addClass("on");
      $(".military_faq .item").find(".text").slideUp();
      $(this).find(".text").slideDown(); 
    }
  });

  $(".military_photos .imageBox").slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          dots: true,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 540,
        settings: {
          dots: true,
          slidesToShow: 1
        }
      }
    ]
  })
  
})

$(function () {
  $(".code_80_off .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".bk-best .itemBox").slick({
    dots: false,
    arrows: true,
    infinite: true,
    touchMove: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $('.bk-discount span').click(function() {
    var data_code = $(this).attr("data-code");
    navigator.clipboard.writeText(data_code);
    var originalTitle = $(this).attr('title');
    $(this).attr('title', 'Copied successfully');
    setTimeout(function() {
      $(this).attr('title', originalTitle);
    }.bind(this), 5000);
  });
  $(".bk-collection .itemBox").slick({
    dots: true,
    arrows: false,
    touchMove: false,
    speed: 1000,
    rows: 2,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  $(".bk-faq .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });
});


$(function () {
  var about_story = new Swiper(".about--history .itemBox", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1201: {
        slidesPerView: 4,
      },
      1000: {
        slidesPerView: 3,
      },
      741: {
        slidesPerView: 2,
      },
      740: {
        slidesPerView: 1,
      }
    }
  });
  var about_story = new Swiper(".story--item", {
    spaceBetween: 40,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1201: {
        slidesPerView: 2
      },
      1200: {
        slidesPerView: 1,
      }
    }
  });
});


$(function(){
  $('.guide-dresses-and-suits .product-list').each(function() {
    const productColor = String($(this).data('color')).toLowerCase();
  
    $(this).find('.color-swatch__item[data-color]').each(function() {
      const swatchColor = String($(this).data('color')).toLowerCase();
  
      if (swatchColor === productColor) {
        $(this).trigger('click');
      }
    });
  });
});

$(function () {
  var custom_photo__swiper = new Swiper(".custom_photo__swiper", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1400: {
        slidesPerView: 5,
      },
      1201: {
        slidesPerView: 4,
      },
      741: {
        slidesPerView: 3,
      },
      640: {
        slidesPerView: 2,
      },
      540: {
        slidesPerView: 1,
      }
    }
  });
});


$(function () {
  var ww = $(window).width();
  if(ww<=1000){
    $("#color-items").slick({
      slidesToShow: 7,
      slidesToScroll: 3,
      arrows: false,
      touchMove: false,
      dots: false,
      centerMode: true,
  	  centerPadding: '0',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 5
          }
        }
      ]
    });

    $('#color-items').on('click', '.item', function(){
      var $this = $(this);
      if ($this.hasClass('active')) {
        $this.removeClass('active');
      } else {
        $('#color-items .item').removeClass('active');
        $this.addClass('active'); 
      }
    });
  }
});

$(function () {
  $('.indexReviewSlick').slick({
    dots: false,
    arrows: true,
    touchMove: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});


 $(document).ready(function() {
  $('.faqSection .list h3').on('click', function() {
    const $parent = $(this).parent('.list');
    const $content = $(this).next('.text');
    $parent.toggleClass('active');
    $content.stop().slideToggle(300); 
  });
});